import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Transformation } from './components/Transformation';
import { PainPoints } from './components/PainPoints';
import { Tomos } from './components/Tomos';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { AboutKarito } from './components/AboutKarito';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
const HERO_CTA_ID = 'hero-cta';
export function App() {
  return <div className="w-full min-h-full bg-cream font-sans text-navy-900 antialiased" data-id="element-0" data-mp="23u9qidp62vsj">
      <MetaPixel data-id="element-1" data-mp="3ikqz80j1f669" />
      <main className="w-full" data-id="element-2" data-mp="3ij65ue8glt9z">
        <Hero ctaId={HERO_CTA_ID} data-id="element-3" data-mp="3ii4t85bsoyq5" />
        <StatsBar data-id="element-4" data-mp="3ml1234bj9ggw" />
        <Transformation data-id="element-5" data-mp="3mkhou0wtvg97" />
        <PainPoints data-id="element-6" data-mp="3mjq3diwy2ywn" />
        <Tomos data-id="element-7" data-mp="3mj6lg27aoaim" />
        <WhatYouGet data-id="element-8" data-mp="3rcj8i7wbs999" />
        <Bonuses data-id="element-9" data-mp="3rbzpsoyupgu6" />
        <Offer data-id="element-10" data-mp="3rdkkqfp2v1sk" />
        <Guarantee data-id="element-11" data-mp="3rd18nfm3z7mg" />
        <Testimonials data-id="element-12" data-mp="3relwkmdx3sbc" />
        <AboutKarito data-id="element-13" data-mp="6hp9c27i9cj" />
        <FAQ data-id="element-14" data-mp="4wyzymxdckh" />
        <FinalCTA data-id="element-15" data-mp="5ggje8nxyxz" />
      </main>
      <Footer data-id="element-16" data-mp="7stte3h7l4p" />
      <FloatingCTA triggerId={HERO_CTA_ID} data-id="element-17" data-mp="2zld2xbxu5jcl" />
      <PurchasePopup data-id="element-18" data-mp="2zmo4r67q0h12" />
    </div>;
}